export class Mindmap {
    public author:String = '';
    public bookname:String = '';
    public clientid:String = '';
    public creator:String = '';
    public currentpage:Number = 1;
    public language:String = '';
    public pagecount:Number = 1;
    public pages:Object = {};
    
}



// WEBPACK FOOTER //
// ./src/app/shared/models/mindmap.ts